// src/app/core/interceptors/version-check.interceptor.ts
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SettingsService } from './services/settings.service';

@Injectable()
export class VersionCheckInterceptor implements HttpInterceptor {
  private _settingsService = inject(SettingsService);
  private hasUserBeenNotifiedFlag = false;

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (
          event instanceof HttpResponse && // It's a successful response
          !this.hasUserBeenNotifiedFlag // We haven't yet notified the user for a new version in this session
        ) {
          // Safety Check: Only respect version headers from non-cached responses
          // Note: Some browsers might not expose all headers on CORS requests without Access-Control-Expose-Headers
          const cacheControl = event.headers.get('Cache-Control') || '';
          if (!cacheControl.toLowerCase().includes('no-store')) {
            return;
          }

          const apiVersion = event.headers.get('X-App-Version');

          if (apiVersion && apiVersion !== this._settingsService.version) {
            // Versions are different!
            this.hasUserBeenNotifiedFlag = true; // Mark as notified for this session

            console.log('The API version does not match the UI version - asking the user to reload...');

            if (confirm('Une nouvelle version de PROTHESIS CLOUD est disponible. Recharger la page maintenant ?')) {
              console.log('The API version does not match the UI version - user has accepted to reload. Reloading the entire app...');
              window.location.reload();
            }

            console.log('The API version does not match the UI version - user has not accepted to reload.');
          }
        }
      }),
    );
  }
}

export const VersionCheckInterceptorProvider = [{ provide: HTTP_INTERCEPTORS, useClass: VersionCheckInterceptor, multi: true }];
